module.exports = __webpack_public_path__ + "static/media/7.010f8eb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/7.png
// module id = 1045
// module chunks = 0